import { CssFeatureSymbol } from '../../ioc/catharsis-ioc'
import { motionTimeAnimations } from './motionTimeAnimationsCompNode'
import type { MotionTimeAnimationsFeature } from './motionTimeAnimations.types'
import { motionTimeAnimationsDomApplier } from './motionTimeAnimationsDomApplier'
import type { BindFeature } from '@wix/thunderbolt-catharsis-ioc'
import { compInfoNodes } from '@wix/thunderbolt-component-isolation'

export const motionTimeAnimationsCssFeature: MotionTimeAnimationsFeature = {
	featureName: 'motionTimeAnimations',
	experimentName: 'specs.thunderbolt.motionTimeAnimationsCSS',
	renderableNodes: { motionTimeAnimations },
	intermediateNodes: { hasResponsiveLayout: compInfoNodes.hasResponsiveLayout },
	dataMaps: ['effects'],
	domApplier: motionTimeAnimationsDomApplier,
	parentMediaRule: 'prefers-reduced-motion: no-preference',
}

export const page: BindFeature = (bind) => {
	bind(CssFeatureSymbol).toConstantValue(motionTimeAnimationsCssFeature)
}

export const editor: BindFeature = page
